
const PurchaseForm = () => import('~/components/Car/PurchaseForm.vue');
export default {
  components: { PurchaseForm },

  fetchOnServer: false,

  data() {
    return {
      cars: [],
    };
  },

  async fetch() {
    await this.fetchCars();
  },

  computed: {
    carAssets() {
      return this.cars.filter((item) => item.category == 'car');
    },
  },

  methods: {
    async fetchCars() {
      try {
        this.$store.commit('temp/PUT', { loading: true });

        const { data } = await this.$axios.request({
          url: '/api/person/account/',
          method: 'get',
        });

        this.cars = data?.results;

        this.$store.commit('temp/PUT', { loading: false });
      } catch (e) {
        this.$store.commit('temp/PUT', { loading: false });
        console.log(e);
      }
    },
  },
};
